// eslint-disable-next-line import/prefer-default-export
export enum Currency {
  AUD = 'AUD',
  USD = 'USR',
  EUR = 'EUR',
}
